/**
 * BottomNav - Bottom navigation bar for device app
 * Simple home button for senior-friendly navigation
 */
import React from 'react';
import { Home, ChevronLeft } from 'lucide-react';

export default function BottomNav({ currentView, onNavigateHome }) {
  // Don't show on home view
  if (currentView === 'home') {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-4 border-gray-200 shadow-2xl z-40">
      <div className="max-w-screen-xl mx-auto px-6 py-4">
        <button
          onClick={onNavigateHome}
          className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-2xl p-4 flex items-center justify-center gap-3 text-2xl font-bold shadow-lg transition-all"
        >
          <ChevronLeft className="w-8 h-8" />
          <Home className="w-8 h-8" />
          Zurück zum Startbildschirm
        </button>
      </div>
    </div>
  );
}
